import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import jmespath from 'jmespath';

export const JqQueryView: React.FC = () => {
  const [json, setJson] = useState<string>('{\n  "locations": [\n    {"state": "WA", "name": "Seattle"},\n    {"state": "NY", "name": "New York"}\n  ]\n}');
  const [query, setQuery] = useState<string>("locations[?state == 'WA'].name");

  const output = (() => {
    try {
      if (!json.trim()) {
        return '';
      }
      const parsed = JSON.parse(json) as unknown;
      const result = jmespath.search(parsed, query || '@') as unknown;
      return JSON.stringify(result, null, 2);
    } catch (err: unknown) {
      if (err instanceof Error) {
        return `// Error: ${err.message}`;
      }
      return `// Error: ${String(err)}`;
    }
  })();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <h2 style={{ margin: 0 }}>Query Editor (JMESPath)</h2>
        <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Filter and extract data from massive JSON arrays directly in the browser.</p>
      </div>
      
      <div style={{ marginBottom: '1rem' }}>
        <input 
          type="text" 
          value={query} 
          onChange={(e) => { setQuery(e.target.value); }} 
          placeholder="Enter JMESPath query (e.g. locations[0].name)"
          style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--color-border)', background: 'var(--color-bg-secondary)', color: 'var(--color-text-primary)', fontFamily: 'monospace' }}
        />
      </div>

      <div style={{ display: 'flex', gap: '1rem', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Editor
            height="100%"
            defaultLanguage="json"
            value={json}
            onChange={(value) => { setJson(value ?? ''); }}
            theme="vs-dark"
            options={{ minimap: { enabled: false }, padding: { top: 16 } }}
          />
        </div>
        </div>
        <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Editor
            height="100%"
            language="json"
            value={output}
            theme="vs-dark"
            options={{ minimap: { enabled: false }, readOnly: true, padding: { top: 16 } }}
          />
        </div>
        </div>
      </div>
    </div>
  );
};
